import React, { useEffect, useState, useContext } from 'react';
import { dbPost } from '../../apis/commonApi';
import { ModalContext } from '../../components/contexts';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';

const TabMutation = ({
  setStartDate,
  setEndDate,
  fetchAlimLogList,
  setCurrentPage,
}) => {
  const tabs = [
    { id: 'tab_00', label: '전체', months: null },
    { id: 'tab_01', label: '3개월', months: 3 },
    { id: 'tab_03', label: '6개월', months: 6 },
    { id: 'tab_04', label: '1년', months: 12 },
    { id: 'tab_05', label: '2년', months: 24 },
    { id: 'tab_06', label: '3년', months: 36 },
  ];

  const [selectedTab, setSelectedTab] = useState('tab_00');

  const handleTabClick = (id, months) => {
    setSelectedTab(id);
    if (months !== null) {
      const today = new Date();
      const pastDate = new Date();
      pastDate.setMonth(today.getMonth() - months);

      const formattedStartDate = pastDate.toISOString().split('T')[0];
      const formattedEndDate = today.toISOString().split('T')[0];

      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);
      fetchAlimLogList(1, formattedStartDate, formattedEndDate);
    } else {
      setStartDate('');
      setEndDate('');
      fetchAlimLogList(1, '', '');
    }
    setCurrentPage(1);
  };

  return (
    <div className="tab full fill tab-mutation">
      <ul role="tablist">
        {tabs.map(tab => (
          <li
            key={tab.id}
            id={tab.id}
            role="tab"
            aria-selected={selectedTab === tab.id}
            className={selectedTab === tab.id ? 'active' : ''}
          >
            <button
              type="button"
              className="btn-tab"
              onClick={() => handleTabClick(tab.id, tab.months)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

const ArlmManage = () => {
  useEffect(() => {
    document.title = '알림관리';
  }, []);

  const { modalService } = useContext(ModalContext);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [alimLogList, setAlimLogList] = useState([]);
  const [receiver, setReceiver] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  const handleStartDateChange = e => {
    const newStartDate = e.target.value;

    if (newStartDate === '') {
      setStartDate('');
      setEndDate('');
      return;
    }

    if (endDate && newStartDate > endDate) {
      modalService.errorAlert('시작 날짜는 종료 날짜보다 늦을 수 없습니다.');
      return;
    }
    setStartDate(newStartDate);
  };

  const handleEndDateChange = e => {
    const newEndDate = e.target.value;

    if (newEndDate === '') {
      setStartDate('');
      setEndDate('');
      return;
    }

    if (!startDate) {
      modalService.errorAlert('먼저 시작 날짜를 선택하세요.');
      return;
    }
    if (newEndDate < startDate) {
      modalService.errorAlert('종료 날짜는 시작 날짜보다 이를 수 없습니다.');
      return;
    }
    setEndDate(newEndDate);
  };

  useEffect(() => {
    fetchAlimLogList(currentPage);
  }, [currentPage]);

const fetchAlimLogList = async (
  page = 1,
  startDateParam = startDate,
  endDateParam = endDate
) => {
  try {
    setIsLoading(true);
    const params = {
      startDate: startDateParam,
      endDate: endDateParam,
      receiver,
      currentPage: page,
    };
    const response = await dbPost('/system/alim/list.do', params);
    setAlimLogList(response.list || []);
    setTotalCount(response.totalCount || 0);
  } catch (error) {
    modalService.errorAlert('알림 로그를 불러오는 중 오류가 발생했습니다.');
    setAlimLogList([]);
  } finally {
    setIsLoading(false);
  }
};

  const reSendAlim = log => {
    modalService.confirmAlert({ msg: '재전송하시겠습니까?' }, [
      () => doResend(log),
      () => {}, 
    ]);
  };

  const doResend = async log => {
    if (log.alrmTp === 'M') {
      try {
        const response = await dbPost('/system/alim/reSendMail.do', log);
        if (response.result === 'success') {
          modalService.successAlert('재전송이 완료되었습니다.');
        } else if (response.result === 'error') {
          modalService.errorAlert('에러가 발생했습니다.');
        } else if (response.result === 'log_not_found') {
          modalService.errorAlert('재전송할 로그 정보를 읽지 못했습니다.');
        }
        setCurrentPage(1);
        fetchAlimLogList(1);
      } catch (error) {
        modalService.errorAlert('서버 요청 중 오류가 발생했습니다.');
        fetchAlimLogList(1);
      }
    } else {
      try {
        const response = await dbPost('/system/alim/reSendAlim.do', log);
        if (response.result === 'success') {
          modalService.successAlert('재전송이 완료되었습니다.');
        } else if (response.result === 'error') {
          modalService.errorAlert('에러가 발생했습니다.');
        } else if (response.result === 'log_not_found') {
          modalService.errorAlert('재전송할 로그 정보를 읽지 못했습니다.');
        }
        setCurrentPage(1);
        fetchAlimLogList(1);
      } catch (error) {
        modalService.errorAlert('서버 요청 중 오류가 발생했습니다.');
        fetchAlimLogList(1);
      }
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchAlimLogList(1);
  };
  
  return (
    <>
      <div className="contents">
        <div className="page-title-wrap" data-type="responsive">
          <h2 className="h-tit">알림관리</h2>
        </div>
        <TabMutation
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          fetchAlimLogList={fetchAlimLogList}
          setCurrentPage={setCurrentPage}
        />
        <div className="search-top-box">
          <div className="sch-filter-box flex">
            <div className="filter-form">
              <div>
                <label className="label" htmlFor="startDate" id="startDateLabel">
                  조회기간
                </label>
                <div className="form-conts datepicker-conts">
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={handleStartDateChange}
                    id="startDate"
                    aria-labelledby="startDateLabel"
                  />
                </div>
                ~
                <label className="hidden-label" htmlFor="endDate" id="endDateLabel">
                  조회기간
                </label>
                <div className="form-conts datepicker-conts">
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={handleEndDateChange}
                    id="endDate"
                    aria-labelledby="endDateLabel"
                  />
                </div>
              </div>

              <div>
                <label className="label" htmlFor="receiver" id="receiverLabel">
                  수신자
                </label>
                <input
                  type="text"
                  className="form-control md"
                  aria-labelledby="receiverLabel"
                  value={receiver}
                  id="receiver"
                  onChange={e => setReceiver(e.target.value)}
                />
              </div>
              <button
                type="button"
                className="btn md primary"
                onClick={handleSearch}
              >
                검색
              </button>
            </div>
          </div>
        </div>
        <div className="tbl-wrap">
          <h3 className="block-tit">기업사용자 목록</h3>
          <div className="tbl-scroll-box">
            <table className="tbl col data">
              <thead>
                <tr>
                  {/* <th scope="col">순번</th> */}
                  <th scope="col">구분</th>
                  <th scope="col">수신자기업</th>
                  <th scope="col">수신자</th>
                  <th scope="col">제목</th>
                  <th scope="col">내용</th>
                  <th scope="col">전송상태</th>
                  <th scope="col">전송일자</th>
                  <th scope="col">재전송</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="9" style={{ textAlign: 'center' }}>
                      데이터 조회 중입니다. 잠시만 기다려주세요.
                    </td>
                  </tr>
                ) : alimLogList.length > 0 ? (
                  alimLogList.map((log, index) => (
                    <tr key={index}>
                      {/* <td>{index + 1}</td> */}
                      <td>
                        <span className="krds-badge outline">
                          {log.alrmTp === 'M' ? 'Email' : '알림톡'}
                        </span>
                      </td>
                      <td>{log.entNm}</td>
                      <td>{log.decNm}</td>
                      <td>
                        {log.alrmTtl.length > 6
                          ? `${log.alrmTtl.substring(0, 6)}...`
                          : log.alrmTtl}
                      </td>
                      <td>
                        {log.decCn.length > 6
                          ? `${log.decCn.substring(0, 6)}...`
                          : log.decCn}
                      </td>
                      <td>
                        <span
                          className={`krds-badge ${
                            log.alrmSndngStts === 'S'
                              ? 'bg3'
                              : log.alrmSndngStts === 'F'
                              ? 'bg4'
                              : 'bg2'
                          }`}
                        >
                          {log.alrmSndngStts === 'S'
                            ? '전송성공'
                            : log.alrmSndngStts === 'F'
                            ? '전송실패'
                            : '재전송'}
                        </span>
                      </td>
                      <td>{log.alrmSndngDt}</td>
                      <td>
                        {log.alrmSndngStts === 'F' && (
                          <button
                            className="btn sm secondary"
                            onClick={() => reSendAlim(log)}
                          >
                            재전송
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={{ textAlign: 'center' }}>
                      데이터가 없습니다.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <GbitTablePaging
            totalItems={totalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default ArlmManage;
